const themes = {
  name: {
    1: 'Kiddy',
    2: 'Ice-cream',
    3: 'Retro 70s',
    4: 'Tubular 80s',
    5: 'Camouflage',
    6: 'Color-blind'
  },
  colors: {
    1: { 1: 'T1C1', 2: 'T1C2', 3: 'T1C3', 4: 'T1C4', 5: 'T1C5', 6: 'T1C6' },
    2: { 1: 'T2C1', 2: 'T2C2', 3: 'T2C3', 4: 'T2C4', 5: 'T2C5', 6: 'T2C6' },
    3: { 1: 'T3C1', 2: 'T3C2', 3: 'T3C3', 4: 'T3C4', 5: 'T3C5', 6: 'T3C6' },
    4: { 1: 'T4C1', 2: 'T4C2', 3: 'T4C3', 4: 'T4C4', 5: 'T4C5', 6: 'T4C6' },
    5: { 1: 'T5C1', 2: 'T5C2', 3: 'T5C3', 4: 'T5C4', 5: 'T5C5', 6: 'T5C6' },
    6: { 1: 'T6C1', 2: 'T6C2', 3: 'T6C3', 4: 'T6C4', 5: 'T6C5', 6: 'T6C6' }
  }
}

export default themes;



// WEBPACK FOOTER //
// ./src/Game/themes.js